export default __webpack_public_path__ + "static/media/ag_15.26921fad.wav";